"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Component2 = _interopRequireDefault(require("../../../Component"));

var _alert = _interopRequireDefault(require("../../templates/content/alert"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = _interopRequireDefault(require("../../../theme"));

var AlertBase =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(AlertBase, _Component);

  function AlertBase() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, AlertBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(AlertBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "template", _alert["default"]);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "submit", function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (event.nativeEvent) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (typeof _this.props.onSubmit === 'function') {
        _this.props.onSubmit();
      }
    });
    return _this;
  }

  return AlertBase;
}(_Component2["default"]);

(0, _defineProperty2["default"])(AlertBase, "defaultProps", {
  needTitle: true,
  title: 'ALERT_INFO_TITLE',
  buttonLabel: 'ALERT_CONFIRM',
  closeAvailable: true
});
(0, _defineProperty2["default"])(AlertBase, "propTypes", {
  closeAvailable: _propTypes["default"].bool,
  needTitle: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  buttonLabel: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func
});
(0, _defineProperty2["default"])(AlertBase, "displayName", 'AlertBase');

var _default = (0, _theme["default"])(AlertBase, 'alertModal');

exports["default"] = _default;